(() => {
  const roots = Array.from(document.querySelectorAll('[data-object-logo-3d]'));

  if (!roots.length) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const canvas = document.createElement('canvas');
  const supportsWebGL = Boolean(
    window.WebGLRenderingContext
      && (canvas.getContext('webgl2') || canvas.getContext('webgl') || canvas.getContext('experimental-webgl'))
  );

  if (reducedMotion || !supportsWebGL) {
    roots.forEach((root) => {
      root.dataset.objectLogoState = 'fallback';
    });
    return;
  }

  const load = async () => {
    try {
      const engineUrl = new URL(roots[0].dataset.engineUrl, window.location.href).href;
      const { mountObjectLogo } = await import(engineUrl);

      roots.forEach((root) => mountObjectLogo(root));
    } catch (error) {
      roots.forEach((root) => {
        root.dataset.objectLogoState = 'fallback';
      });
    }
  };

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(load, { timeout: 800 });
  } else {
    window.setTimeout(load, 0);
  }
})();
